import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Group, Text } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
export type BackButtonProps = {
  handleClick: () => void;
};
export const BackButton: React.FC<BackButtonProps> = ({
  handleClick
}) => {
  const {
    i18n
  } = useLingui();
  return <Group gap={4} align="center" onClick={handleClick} c="var(--text-dark)" style={{
    cursor: 'pointer'
  }}>
      <IconArrowLeft size={24} style={{
      marginBottom: 4
    }} />
      <Text fz={{
      base: 14,
      sm: 20
    }} lh="20px" className={gunterzBold.className} c="inherit">
        {i18n._('Buy crypto using cards')}
      </Text>
    </Group>;
};